import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=10d7f22d&scoped=true"
import script from "./LogsTable.vue?vue&type=script&lang=js"
export * from "./LogsTable.vue?vue&type=script&lang=js"
import style0 from "./LogsTable.vue?vue&type=style&index=0&id=10d7f22d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7f22d",
  null
  
)

export default component.exports